/* istanbul ignore file */
export default {
  sizeToParent() {
    return undefined;
  },
  flag: {
    create: function ({ title, body, type, close }) {
      const AJS = getAJS();

      return AJS.flag({
        title,
        body,
        type,
        close,
      });
    },
  },
  events: {
    emit: function (uniqueKey: string) {
      const AJS = getAJS();
      AJS?.$(window.document).trigger(uniqueKey);
    },
    on: function (uniqueKey: string, callback: () => void) {
      const AJS = getAJS();
      AJS?.$(window.document).on(uniqueKey, callback);
    },
    // there's no public version for Server, it's here just to fullfill missing method
    onPublic: function (uniqueKey: string, callback: () => void) {
      const AJS = getAJS();
      AJS?.$(window.document).on(uniqueKey, callback);
    },
  },
  navigator: {
    go: function (_screen: string, details: any) {
      window.open(details.absoluteUrl, '_top');
    },
    reload: function () {
      window.location.reload(false);
    },
  },
};

function getAJS() {
  let AJS;
  if (window.frameElement !== null && window.frameElement !== undefined) {
    AJS = window.parent.AJS;
  } else {
    AJS = window.AJS;
  }
  return AJS;
}
